// src/components/SinisterCardData/sections.ts

import {
	AttachMoney,
	CalendarToday,
	DateRange,
	EditNoteOutlined,
	Email,
	Home,
	MailOutline,
	PeopleAlt,
	Person,
	Phone,
	PhoneAndroid,
	Portrait,
	Security,
	SubjectOutlined,
	Summarize,
} from "@mui/icons-material";
import { differenceInYears } from "date-fns";
import { globalFormatCurrencyBRL, globalFormatDates, globalMaskDocument, globalTranslate, maskPhone } from "../../../../shared/utils";
import { getDurationLabelFromRawDates } from "../../../../shared/utils/dateUtils";
import { ISinisterRow, SectionConfigSinister } from "../../types/fieldsconfig";
import { CalendarIcon } from "@mui/x-date-pickers";

export const buildSinisterSections = (
	rows: ISinisterRow,
	sumLmi: { lmiTotal: string; saldo: string },
	totalBordero: number,
	responsibleName: string
): SectionConfigSinister[] => [
	{
		title: "Dados do Sinistro",
		rows: [
			{
				fields: [
					{ label: "Certificado", value: rows?.proposal?.certificateNumber, icon: <Security />, colSpan: 4 },
					{ label: "Criação sinistro", value: globalFormatDates(rows?.createdAt), icon: <CalendarToday />, colSpan: 4 },
					{
						label: "Abertura - Encerramento",
						value: `${globalFormatDates(rows.openAt)} a ${globalFormatDates(rows.finalizedAt)}`,
						icon: <DateRange />,
						additionalInfo: getDurationLabelFromRawDates(rows.openAt, rows.finalizedAt),
						colSpan: 4,
					},
				],
			},
			{
				fields: [
					{ label: "Situação do Imóvel", value: globalTranslate(rows?.busyProperty?.toString()), icon: <Home />, colSpan: 4 },
					{ label: "Responsável abertura do sinistro", value: rows.client.name, icon: <PeopleAlt />, colSpan: 4 },
					{ label: "Responsável pelo Sinistro", value: responsibleName, icon: <PeopleAlt />, colSpan: 4 },
				],
			},
			{
				fields: [
					{ label: "LMI", value: sumLmi?.lmiTotal, valueFormatter: globalFormatCurrencyBRL, icon: <AttachMoney />, colSpan: 4 },
					{ label: "Saldo LMI", value: sumLmi?.saldo, valueFormatter: globalFormatCurrencyBRL, icon: <AttachMoney />, colSpan: 4 },
					{ label: "Total de Borderôs", value: totalBordero, icon: <Summarize />, colSpan: 4 },
				],
			},
			{
				fields: [
					{
						label: "Endereço do risco",
						value: `${rows.proposal.addressStreet} ${rows.proposal.addressNumber}${
							rows.proposal.addressComplement ? `, ${rows.proposal.addressComplement}` : ""
						} - ${rows.proposal.addressDistrict} - ${rows.proposal.addressCity} - ${rows.proposal.addressState} - ${rows.proposal.addressZipcode}`,
						icon: <Security />,
						colSpan: 12,
					},
				],
			},

			...(rows.status === "canceled"
				? [
						{
							fields: [
								{ label: "Cancelado em", value: globalFormatDates(rows?.canceledAt), icon: <CalendarIcon />, colSpan: 4 },
								{ label: "Motivo do cancelamento", value: rows?.canceledReason, icon: <SubjectOutlined />, colSpan: 6 },
								{
									label: "Anotação do cancelamento",
									value: rows?.canceledObs,
									icon: <EditNoteOutlined />,
									colSpan: 6,
								},
							],
						},
				  ]
				: []),
		],
	},
	{
		title: "Dados Inquilino",
		rows: [
			{
				fields: [
					{ label: "Nome", value: rows?.proposal?.name, icon: <Person />, colSpan: 4 },
					{ label: "Documento", value: rows?.proposal?.document, icon: <Portrait />, valueFormatter: globalMaskDocument, colSpan: 4 },
					{
						label: "Nascimento",
						value: rows?.proposal?.birthDate,
						icon: <CalendarToday />,
						valueFormatter: globalFormatDates,
						additionalInfo: rows?.proposal?.birthDate
							? `(${differenceInYears(new Date(), new Date(rows.proposal.birthDate))} anos)`
							: "Não informado",
						colSpan: 4,
					},
				],
			},

			{
				fields: [
					{ label: "Telefone", value: maskPhone(rows?.proposal?.phone), icon: <PhoneAndroid />, colSpan: 4 },
					{ label: "Celular", value: maskPhone(rows?.proposal?.mobilePhone), icon: <Email />, colSpan: 4 },
					{ label: "Email", value: rows?.email, icon: <Email />, colSpan: 4 },
				],
			},
		],
	},
	{
		title: "Dados do parceiro",
		rows: [
			{
				fields: [
					{ label: "Nome", value: rows?.client?.name, icon: <Person />, colSpan: 4 },
					{ label: "Documento", value: rows?.client?.document, icon: <Portrait />, valueFormatter: globalMaskDocument, colSpan: 4 },
					{ label: "Email", value: rows?.client?.email, icon: <MailOutline />, colSpan: 4 },
				],
			},
			{
				fields: [
					{ label: "Telefone", value: maskPhone(rows?.client?.phone), icon: <Phone />, colSpan: 4 },
					{ label: "Celular", value: maskPhone(rows?.client?.mobilePhone), icon: <PhoneAndroid />, colSpan: 4 },
				],
			},
		],
	},
];
